<template>
<div class="test">
  <ul>
    <li v-for="item in 50" :key="item" v-html="content" v-lazy-container="{ selector: 'img' }">

    </li>
  </ul>
</div>
</template>

<script>
export default {
  name: "test",
  data() {
    return {
      content: '<img data-src="//images.h-ui.net/www/AD-300x250.gif" class="lazyload" alt="" width="320" height="250" style="display: inline;">'
    }
  },
   methods: {

   },
   mounted() {

   }
}
</script>

<style scoped>

</style>